import { useLang } from '../hooks/useLang';
import './LanguageToggle.css';

export default function LanguageToggle() {
    const [lang, setLang] = useLang();
    return (
        <div className="lang-toggle" role="group" aria-label="Interface language">
            <button
                type="button"
                className={
                    lang === 'en' ? 'lang-toggle__btn is-active' : 'lang-toggle__btn'
                }
                aria-pressed={lang === 'en'}
                onClick={() => setLang('en')}
                title="English UI"
            >
                EN
            </button>
            <span aria-hidden="true" className="lang-toggle__sep">
                /
            </span>
            <button
                type="button"
                lang="ta"
                className={
                    lang === 'ta' ? 'lang-toggle__btn is-active' : 'lang-toggle__btn'
                }
                aria-pressed={lang === 'ta'}
                onClick={() => setLang('ta')}
                title="Tamil UI"
            >
                த
            </button>
        </div>
    );
}
